// Skærmlæser: to aria-live-områder. Høflige beskeder venter, vigtige (blackout) afbryder.

let polite: HTMLElement | null = null;
let assertive: HTMLElement | null = null;
const recent = new Map<string, number>();
/**
 * En besked i et live-område er læst op efter få sekunder. IGN-løkke 2 (runde 2): områderne blev
 * aldrig tømt, så "Spidsbølge på vej. Vælg et svar på kortet." stod i siden et helt år efter svaret
 * og blev læst igen af en skærmlæser, der gik tilbage. Teksten lever nu kun, mens den er ny.
 */
export const LIVE_MS = 5000;
const clearTimers = new WeakMap<HTMLElement, number>();

export function initA11y(root: HTMLElement): void {
  polite = document.createElement('div');
  polite.className = 'sr-only';
  polite.setAttribute('aria-live', 'polite');
  polite.setAttribute('role', 'status');
  assertive = document.createElement('div');
  assertive.className = 'sr-only';
  assertive.setAttribute('aria-live', 'assertive');
  assertive.setAttribute('role', 'alert');
  root.append(polite, assertive);
}

/** Læs en kort besked op. Samme besked gentages højst hvert 4. sekund. */
export function announce(text: string, urgent = false): void {
  const el = urgent ? assertive : polite;
  if (!el) return;
  const now = performance.now();
  if (now - (recent.get(text) ?? -1e9) < 4000) return;
  recent.set(text, now);
  el.textContent = '';
  window.clearTimeout(clearTimers.get(el));
  // Et frisk tekstnode sikrer, at læseren opfanger ændringen.
  window.setTimeout(() => {
    el.textContent = text;
    clearTimers.set(
      el,
      window.setTimeout(() => {
        if (el.textContent === text) el.textContent = '';
      }, LIVE_MS),
    );
  }, 30);
}

/** Tøm begge områder: en ny bane må ikke arve forrige banes sidste besked. */
export function clearLive(): void {
  recent.clear();
  if (polite) polite.textContent = '';
  if (assertive) assertive.textContent = '';
}
